import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useAssetDetails } from '../../forces/assetDetails/useAssetDetails';
import { getSuperCoverPageLink } from '../../router/router.deepLinks';
import { AssetNotFound } from '../errorPage/AssetNotFound';

import { CoverPageLoader } from './CoverPageLoader';

/**
 * redirects old watch/vod routes to super cover page
 */
export const RedirectOldCoverPageVod: FC<{ assetId: string }> = ({ assetId }) => {
  const { data: asset, isLoading } = useAssetDetails(assetId);

  if (isLoading) {
    return <CoverPageLoader />;
  }

  const scpLink = asset && getSuperCoverPageLink(asset);
  if (scpLink) {
    // redirect / upgrade to new super cover page
    return <Navigate to={scpLink + location.search} replace />;
  }

  return <AssetNotFound contextInfo={`unable to redirect to SCP from assetId=${assetId}`} />;
};
